export interface ReporterI {
    start: (...args: unknown[]) => void;
    end: (details?: Record<string, unknown>) => void;
    mark: (...args: [string, Record<string, unknown>]) => void;
}

export default class Reporter implements ReporterI {

    startTime: number | null = null;
    meta = {}
    reporters: ReporterI[] = [];

    start(...args: unknown[]) {
        this.startTime = performance.now();

        this.reporters.forEach((rep) => rep.start(...args));
    }

    end(detail?: Record<string, unknown>) {
        this.reporters.forEach((rep) => rep.end(detail));

        this.meta = { ...this.meta, ...detail, startTime: this.startTime };
    }

    mark(...args: [string, Record<string, unknown>]) {
        this.reporters.forEach((rep) => rep.mark(...args));
    }

    addReporter(reporter: ReporterI) {
        this.reporters.push(reporter);
    }

}
